import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, Suspense, lazy } from "react";
import { MuiMarkdownComponents } from "./MuiMarkdownComponents";
const ReactMarkdown = lazy(() => import("react-markdown"));
/**
 * Markdown renderer
 *
 * @export
 * @param  src
 * @returns Markdown
 */
export function Markdown(props) {
    const { src } = props;
    if (!src) {
        return _jsx(Fragment, {});
    }
    // we could use transformImageUri, but it is a security risk, see https://github.com/remarkjs/react-markdown#security
    return (_jsx(Suspense, { children: _jsx(ReactMarkdown, { components: MuiMarkdownComponents, children: src }) }));
}
//# sourceMappingURL=Markdown.js.map